/**
 * bic-bim-api
 * Import from bic-bim-api Function App
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * Status eines asynchronen Checks
 */
export interface CheckStatusResponse { 
    /**
     * Aktueller Status des Checks
     */
    status: CheckStatusResponse.StatusEnum;
    /**
     * JSON-String mit dem Ergebnis des Checks (nur bei status=Completed, sonst null)
     */
    output?: string;
}
export namespace CheckStatusResponse {
    export type StatusEnum = 'Running' | 'Completed';
    export const StatusEnum = {
        Running: 'Running' as StatusEnum,
        Completed: 'Completed' as StatusEnum
    };
}